import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';

// PrimeNG Modules
import { SidebarModule } from 'primeng/sidebar';

// Layout Components
import { AdminLayoutComponent } from './admin-layout/admin-layout.component';
import { PublicLayoutComponent } from './public-layout/public-layout.component';
import { PublicLandingPageLayoutComponent } from './public-landing-page-layout/public-landing-page-layout.component';
import { StudentLayoutComponent } from './student-layout/student-layout.component';
import { StudentViewLayoutComponent } from './student-view-layout/student-view-layout.component';

// Common Components Module
import { CommonComponentsModule } from '../common/common.module';

// UI Component Modules
import { TypographyComponentModule } from '../common/ui/typography/typography.module';
import { ModalComponentModule } from '../common/ui/modal/modal-component.module';
import { ButtonComponentModule } from '../common/ui/button/button-component.module';

@NgModule({
  declarations: [
    AdminLayoutComponent,
    PublicLayoutComponent,
    PublicLandingPageLayoutComponent,
    StudentLayoutComponent,
    StudentViewLayoutComponent
  ],
  imports: [
    CommonModule,
    RouterModule,
    SidebarModule,
    CommonComponentsModule,
    TypographyComponentModule,
    ModalComponentModule,
    ButtonComponentModule
  ],
  exports: [
    AdminLayoutComponent,
    PublicLayoutComponent,
    PublicLandingPageLayoutComponent,
    StudentLayoutComponent,
    StudentViewLayoutComponent
  ]
})
export class LayoutsModule { }
